<template>
    <div class="bg-white rounded shadow-sm mb-3">
        <!-- {{ dataTable }} -->
        <div class="d-flex flex-row align-items-center justify-content-between mb-3" style="padding: 20px">
            <h4 class=" font-weight-semibold" style="color: #000000;;">Riwayat Kirim QR
                <!-- <i class="fa fa-info-circle fa" id="riwayatPengiriman"></i>
                    <b-popover
                    target="riwayatPengiriman"
                    title="QR Issue History"
                    triggers="hover focus"
                    placement="top"
                    :content="'Tabel ini menampilkan riwayat pengiriman QR ke dealer.'"
                    ></b-popover> -->
            </h4>
            <div class="d-flex align-items-center">

                <div class="mr-3" style="background-color: white; border-radius: 4px; position: relative; border: 0">
                    <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                        <i class="fas fa-calendar"></i>
                    </span>
                    <flat-pickr ref="datepicker" v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                </div>

                <div class="mr-3 text-nowrap">
                    <MultiSelect
                        v-model="filter.status"
                        :options="['INTRANSIT' , 'RECEIVED']"
                        class="qtrust-select"
                        placeholder="Semua Status"
                    ></MultiSelect>
                </div>

            </div>
        </div>

        <div class="w-100 overflow-auto">
            <table class="table w-100 qtrust-table">
               <thead>
                    <tr>
                        <th>Tanggal Pengiriman</th>
                        <th>Jumlah QR</th>
                        <th>Kode Pos</th>
                        <th>Nama Pos</th>
                        <th>Status Jaringan</th>
                        <th>Status</th>
                        <th>Kode BAST</th>
                        <th>Nama Pengirim</th>
                        <th>Tanggal Receipt</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="data" v-for="(dat, index) in data">
                        <td>{{ dat.delivery_at ? moment(dat.delivery_at).format('DD MMM YYYY | HH:mm') : '-' }}</td>
                        <td>{{ dat.qty ? numberWithCommas(dat.qty) : '-' }}</td>
                        <td>{{ dat.kode_dealer ? dat.kode_dealer : '-'  }}</td>
                        <td>{{ dat.dealer ? dat.dealer : '-'  }}</td>
                        <td>{{ dat.dealer_type ? dat.dealer_type : '-' }}</td>
                        <td>{{ dat.status ? dat.status : '-' }}</td>
                        <td>{{ dat.bast_no ? dat.bast_no : '-' }}</td>
                        <td>{{ dat.sender_name ? dat.sender_name : '-' }}</td>
                        <td>
                            {{ dat.received_at ? moment(dat.received_at).format('DD MMM YYYY | HH:mm') : '-' }}
                            
                        </td>
                        <td>
                         <div class="d-flex justify-content-between" v-if="$store.state.userData.userData.role !== 'USER SE'">
                                <i v-if="dat.status == 'INTRANSIT'" class="fa fa-edit text-primary ml-2 clickHover" title="Edit"  @click="$emit('editData', dat)"></i>
                                <i v-if="dat.status == 'INTRANSIT'" class="fa fa-trash text-danger ml-2 clickHover" title="Hapus" @click="deleteQRIssue(dat.id)"></i>
                                <!-- <i v-if="dat.received_at" class="fa fa-file-download ml-2 clickHover" title="Download BAST" @click="printReceiptMethod(dat)"></i> -->
                                <i class="fa fa-file-download ml-2 clickHover" title="Download BAST" @click="printReceiptMethod(dat)"></i>
                            </div>
                            <div class="d-flex justify-content-between" v-else>
                                <i class="fa fa-file-download ml-2 clickHover" title="Download BAST" @click="printReceiptMethod(dat)"></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-end align-items-center py-2 px-3" v-if="data">
            <p class="text-muted mb-0">Showing {{ (config.page-1)*config.limit+1 }}-{{ (config.page-1)*config.limit+data.length }} of {{ config.total }} items</p>
            <div class="d-flex align-items-center text-muted ml-3">
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(1)"><i class="fa fa-angle-double-left"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page <= 1" @click="goToPage(config.page - 1)"><i class="fa fa-angle-left"></i></button>
                <p class="px-2 text-dark mb-0">{{ config.page }}</p>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.page + 1)"><i class="fa fa-angle-right"></i></button>
                <button class="btn btn-link px-1" style="color: #627884" :disabled="config.page >= config.lastPage" @click="goToPage(config.lastPage)"><i class="fa fa-angle-double-right"></i></button>
            </div>
        </div>
        
        <print-receipt ref="printReceiptComponent" :data="receiptData"/>
    </div>
</template>

<script>
    import moment from 'moment';
    import qs from 'qs'
    import debounce from 'debounce'
    import PrintReceipt from './printReceipt.vue'

    export default {
        data () {
            let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
            let end = moment().format("YYYY-MM-DD");
            return {
                moment,
                // dataTable : null,
                // metaTable : null,
                receiptData : null,
                dateRangeConfig: {
                    mode: "range",
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altInputClass: "flatpickr-alt",
                    onOpen: this.onFlatpickrOpen,
                    onClose: this.onCloseFlatpickr
                },
                data : null,
                selected: {
                    date: `${start} to ${end}`,
                },
                afterSelectedFilter: false,
                filter : {
                    status : null,
                    start_date : start,
                    end_date : end,
                },
                config : {
                    page: 1,
                    limit: 15,
                    lastPage: 0,
                    total: 0,
                    sort_by: 'delivery_at',
                    sort_order: 'DESC'
                },
            }
        },
        components : {
            PrintReceipt
        },
        watch : {
            // 'selected.date'() {
            //     let dates = this.selected.date.split(' to ');
            //     // console.log('dates', dates)
            //     // this.debounceMethod(dates , this)
            // },
            'filter' : {
                deep: true,
                handler () {
                    this.config.page = 1;
                    this.generateDatas();
                },
            },
            'config.page' : {
                deep: true,
                handler: 'generateDatas'
            }
        },
        mounted () {
            this.generateDatas()
        },
        methods : {
            goToPage(page) {
                if (page >= 1 && page <= this.config.lastPage) this.config.page = page;
            },
            sortClick(sort_by) {
                if (this.config.sort_by == sort_by) {
                    this.config.sort_order = this.config.sort_order == 'asc' ? 'desc' : 'asc';
                } else {
                    this.config.sort_by = sort_by;
                    this.config.sort_order = 'desc';
                }
                this.generateDatas();
            },
            async printReceiptMethod(data) {
                // console.log(this.$refs.printReceipt)
                try {

                    let id = data.id
                    let response = await this.$http.get('/api/qrs/issue/' + id)

                    this.receiptData = response.data.data

                    this.$refs.printReceiptComponent.generateReport()
                }
                catch(err) {
                    console.log(err)
                }
                
            },
            showBast () {

            },
            debounceMethod: debounce((dates, vm) => {
                vm.filter.start_date = dates[0];
                vm.filter.end_date = dates[1] ? dates[1] : dates[0];
            }, 1000),
            async generateDatas() {
                let filter = JSON.parse(JSON.stringify(this.filter));
                let configs = JSON.parse(JSON.stringify(this.config));
                delete configs.lastPage;
                delete configs.total;

                this.$http.get(`/api/qrs/issue?`, {params: {...filter, ...configs, sender_only: 1}})
                .then(async res => {
                    let data = res.data.data;
                    this.data = data;

                    this.config.lastPage = res.data.meta.lastPage;
                    this.config.total = res.data.meta.total;

                    this.$nextTick(() => {
                        document.dispatchEvent(new Event('click'));
                    });
                })
                .catch((err)=>console.log(err));
            },
            deleteQRIssue(issueId) {
                this.$swal.fire({
                    html: `<div class="text-center my-2" style="color: #000000;"><h4>Apakah Anda yakin?</h4>
                        <div>Data yang telah dihapus tidak dapat dikembalikan lagi</div>               
                        </div>`,
                    type : 'warning',
                    showCancelButton: true,
                    cancelButtonText: `Batal`,
                    confirmButtonText: `Hapus`,
                    reverseButtons: true,
                    customClass: {
                        confirmButton: "btn btn-danger btn-lg mx-2",
                        cancelButton: "btn btn-outline btn-outline-danger btn-lg mx-2"
                    },
                    buttonsStyling: false
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.value) {
                        
                        this.$http.delete(`/api/qrs/issue/${issueId}`)
                        .then((resp) => {
                            this.generateDatas()
                            this.$emit('refreshSaldo')
                        })
                        .catch((err) => {
                            console.log(err)
                            this.$swal.fire({
                                title: "Error",
                                text: (err && err.message) ? err.message : "Gagal menghapus data",
                                icon: "error",
                            });
                        })
                    }
                })
            },
            onCloseFlatpickr(selectedDates) {
                if (selectedDates.length === 2) {
                    const formatDate = (date) => {
                        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                    };

                    const date1 = formatDate(selectedDates[0]);
                    const date2 = formatDate(selectedDates[1]);
                    this.debounceMethod([date1, date2], this);
                    this.afterSelectedFilter = true;

                }   
            },
            onFlatpickrOpen(selectedDates) {
                if (this.afterSelectedFilter) {
                    this.$refs.datepicker.fp.close();
                    this.afterSelectedFilter = false;
                }
                
            },
        },
    }
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
    }

    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 14px;
        color: black;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 14px;
    }
</style>

<style scoped>
    .clickHover:hover {
        cursor: pointer;
        /* opacity: 70% !important; */
    }

    .qtrust-table > thead > tr > th {
        text-align: left;
        border-top: 2px solid #F3F3F3;
        border-bottom: 2px solid #F3F3F3;
        padding: 8px 16px;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-table > tbody > tr > td {
        text-align: left;
        padding: 8px 16px;
        border-bottom: 1px solid #F3F3F3;
        height: 50px;
        vertical-align: middle;
    }

    .qtrust-custom-select {
        border:1px solid #E8E8E8;
        min-width: 100px;
        /* width: 100px; */
        display: inline-block;
        border-radius: 4px;
        position: relative;
    }
    .qtrust-custom-select select {
        width: 100%;
        height: 100%;
        padding: 2px 5px;
    }
    .flatpickr-alt {
        pointer-events: none; /* Prevents unwanted reopen */
    }
</style>